<template>
    <article v-if="videoFile" class="scrolled-video">
        <div class="scrolled-video__wrapper">
            <div class="image__radius">
                <video
                    :poster="videoPoster?.thumbnail"
                    preload="none"
                    ref="$video"
                    loop
                    muted
                    :controls="controls"
                >
                    <source v-if="activeSrc" :src="activeSrc" type="video/mp4" />
                    Your browser doesn't support HTML5 video tag.
                </video>
            </div>
        </div>
        <div class="scrolled-video__info">
            <button class="btn-play" @click="startPlay">
                <SvgsPlay :fill="'var(--dark)'" />
            </button>
            <div class="video-info">
                <div class="video-link">Watch video</div>
                <div class="video-duration">{{ duration }}</div>
            </div>
        </div>
    </article>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: Object,
            default: () => ({})
        }
    });

    const $video = ref(null);
    const duration = ref(null);
    const controls = ref(false);
    const videoPoster = computed(() => useCmsFirst(props.data.videoPoster));
    const videoFile = computed(() => useCmsFirst(props.data.video));

    const { activeSrc, ensureLoaded } = useDeferredVideo($video, {
        src: () => videoFile.value?.url,
        autoplayWhenVisible: false,
        waitForAppReady: true,
        loadOnDemand: true
    });

    const convertDuration = (duration) => {
        const min = Math.floor(duration / 60);
        const sec = Math.floor(duration - min * 60);

        return `${min}:${sec}`;
    };

    const startPlay = async () => {
        await ensureLoaded();
        controls.value = true;
        const el = $video.value;
        if (el?.duration) duration.value = convertDuration(el.duration);
        el?.addEventListener(
            "loadedmetadata",
            () => {
                duration.value = convertDuration(el.duration);
            },
            { once: true }
        );
        el?.play();
    };
</script>
